import { get, post } from '../utils/request';

export const user = {
  /**
   * 获取微信咨询顾问qrcode
   */
  getWechatInquiry(params) {
    const path = '/backend/v1/user/wehcat-inquiry/';
    return get(path, params);
  },

  /**
   * 电话咨询
   */
  submitPhoneInquiry(data: any) {
    const path = '/backend/v1/user/phone-inquiry/';
    return post(path, data);
  },
};

export default user;
